import React from 'react';
import { useSelector } from 'react-redux';
import {
  beatWaveListSelector,
  waveLinksSelector,
} from '../../wave/selectors/wave.selectors';
import { useStrip } from '../hooks/useStrip';
import { LaddergramItem } from './LaddergramItem';
import { LaddergramLink } from './LaddergramLink';

export const Laddergram: React.FC = () => {
  const waves = useSelector(beatWaveListSelector);
  const links = useSelector(waveLinksSelector);
  const { xScale, onset } = useStrip();

  return (
    <g className='laddergram' transform={`translate(${xScale(onset)} 0)`}>
      {links.map(({ pWave, qrsWave }) => (
        <LaddergramLink
          start={(pWave.offset + pWave.onset) / 2}
          end={(qrsWave.offset + qrsWave.onset) / 2}
          key={pWave.id}
        />
      ))}
      {waves.map(({ id }) => (
        <LaddergramItem waveId={id} key={id} />
      ))}
    </g>
  );
};
